// extracted by mini-css-extract-plugin
module.exports = {"candidateContent":"TRIJqbXt","candidateHeader":"_3d7BIKNS","candidateHeaderText":"_3Aj9G5pD","logoWrapper":"_3xeEybGs","statusContent":"PaXMNYx4","dateContent":"Ia6xeyKU","companyHeader":"_1SphMpPG","otherHeader":"_2SRGK3H3","blockTitle":"_2hFsylnO","actionsContent":"_1PLPtFhC","candActionHeader":"_2ausVPCE","statusHired":"_2qPl25ED","statusPassed":"E_jGhn-z","stack":"tXlvYjQz"};
    if(module.hot) {
      // 1754515042687
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  